import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Results.MddCurveFittingAlgorithm`]: 'Curve Fitting',
      [`cwdChart.XAxisMin`]: 'Moisture Content Start',
      [`cwdChart.XAxisMajorStep`]: 'Moisture Content Division Size',
      [`cwdChart.YAxisToXAxisStepRatio`]: 'Converted Wet Density to Moisture Content Ratio',

      [`mddChart.XAxisMin`]: 'Moisture Content Start',
      [`mddChart.XAxisMajorStep`]: 'Moisture Content Division Size',
      [`mddChart.YAxisToXAxisStepRatio`]: 'Dry Density to Moisture Content Ratio',
    }),
    convertLabelUomMapToConfig({
      [`cwdChart.XAxisMin`]: '%',
      [`cwdChart.XAxisMajorStep`]: '%',

      [`mddChart.XAxisMin`]: '%',
      [`mddChart.XAxisMajorStep`]: '%',
    })
  );

export default getLabelConfig;
